import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContactModalComponent} from './contact-modal.component';
import {ReactiveFormsModule} from '@angular/forms';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [ContactModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModalModule
  ]
})
export class ContactModalModule {
}
